import { render } from "./DoubleConfirmationButton.vue?vue&type=template&id=4d647304"
import script from "./DoubleConfirmationButton.vue?vue&type=script&lang=js"
export * from "./DoubleConfirmationButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__